import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DescriptionBuilder from './DescriptionBuilder'
import { updateCalculatorAction } from 'actions/calculatorActions'
import { updateEntityAction } from 'actions/entityActions'
import { updateUiAction } from 'actions/uiActions'
import Clipboard from 'clipboard'

class DeviceDescription extends React.Component {
  constructor(props) {
    super(props)
    this.timer = null
    this.state = { copied: false }
  }

  componentDidMount = _ => new Clipboard(`.${this.props.classes.copyButton}`)
  componentWillUnmount = _ => clearTimeout(this.timer)

  getCopyButtonText = _ => {
    const { type, currentDevice } = this.props
    const typeName = type === 'wiredDevice' ? currentDevice.type : type.replace(/[A-Z]/, m => ' ' + m.toLowerCase())

    return `Copy ${typeName} description to clipboard`
  }

  updateNotes = ({ target: { value } }) => {
    const { type, currentDevice: { id }, updateCalculatorAction, updateEntityAction } = this.props

    if (type === 'camera') updateCalculatorAction(value, 'notes', this.props.currentDevice.id, false)
    else updateEntityAction(type + 's', id, { notes: value })
  }

  setCopied = _ => {
    this.setState({ copied: true })
    this.timer = setTimeout(_ => this.setState({ copied: false }), 2000)
  }

  locationLink = key => {
    const { updateUiAction, currentDevice, classes } = this.props

    return (
      <div>
        <span className={classes.bold}>
          {key === 'lat' ? 'Latitude' : 'Longitude'}
        </span>
        <a
          onClick={_ => updateUiAction({ modal: 'EditLocation' })}
          className={classes.locationLink}
        >
          {currentDevice.location[key]}
          <FontAwesomeIcon icon='edit' className={classes.locationEdit} />
        </a>
      </div>
    )
  }

  render() {
    const { setCopied, getCopyButtonText, props: { currentDevice, skipLocation, type, classes }, state: { copied } } = this

    return (
      <div>
        { !skipLocation &&
          <div>
            { this.locationLink('lat') }
            { this.locationLink('lng') }
          </div>
        }
        <textarea
          onChange={this.updateNotes}
          value={currentDevice.notes}
          className={classes.textarea}
          placeholder='Notes'
        />
        <DescriptionBuilder currentDevice={currentDevice} type={type} />
        <button
          className={classes.copyButton}
          onClick={setCopied}
          data-clipboard-target='#deviceDescriptionWrapper'
        >
          { copied ? 'Copied!' : getCopyButtonText() }
        </button>
      </div>
    )
  }
}

export default connect(null, { updateCalculatorAction, updateEntityAction, updateUiAction })(
  injectSheet(style)(DeviceDescription)
)



// WEBPACK FOOTER //
// ./src/components/DeviceDescription/index.js